import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    minHeight: '9rem',
  },
});

export default useStyles;
